<template lang="pug">
  Layout
    ResetTwoFactorSecretKey(:submit-fn="resetTwoFactorSecretKey")
      template(v-slot:default="{ open }")
        v-tooltip(right)
          template(v-slot:activator='{ on }')
            v-btn.ml-4(
              outlined,
              v-on="on",
              :disabled="!user.two_factor_enabled",
              :color="user.two_factor_enabled ? 'primary' : 'grey'",
              @click="open",
            )
              v-icon(left) fas fa-fingerprint
              | Two factor enabled
          span Reset user secret key    

    FormWrapper(type="password")
      template(v-slot:default="props")
        PasswordForm(
          :model="props.model",
          :redirect-route="{ name: 'editUser', params: { id: $route.params.id } }",
          :submit-fn="submitFn",
          :validate="props.validate",
          :valid="props.valid",
        )
</template>

<script>
import { mapGetters } from 'vuex';
import { mergeRight } from 'ramda';
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Layout from '@/layouts/User.vue';
import PasswordForm from '@/components/forms/Password.vue';
import ResetTwoFactorSecretKey from '@/components/forms/ResetTwoFactorSecretKey.vue';

export default {
  components: {
    FormWrapper,
    Layout,
    PasswordForm,
    ResetTwoFactorSecretKey,
  },

  computed: {
    ...mapGetters({ user: 'user/user' }),
  },

  methods: {
    submitFn(payload) {
      return this.$store.dispatch(
        'user/updatePassword',
        mergeRight(payload, { id: this.$route.params.id }),
        {
          root: true,
        },
      );
    },

    resetTwoFactorSecretKey() {
      return this.$store.dispatch(
        'user/resetTwoFactorSecretKey',
        this.$route.params.id,
      );
    },
  },
};
</script>
